import { CommonEtat } from "@core-lib/enums";

export function hasMotifRenvoi(etat: CommonEtat): boolean {
    const motifsRenvoi = [
        CommonEtat.RenvoyePourModifAuFO,
        CommonEtat.RenvoyePourInfoAuFO
    ];

    return motifsRenvoi.includes(etat);
};